/** @jsx jsx */
import { css } from "@emotion/react";
import Bgteste from '../images/LP-arabe/bg-teste-arabe.svg'
import videoShapeMobile from '../images/LP-versar/stars-mobile.png'

export const testeArabeStyle = css`
  background-color: #FD6F2F;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 108px 0;
  background-image: url(${Bgteste});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 25%;
  scroll-margin-top: 70px;

  @media (max-width: 850px) {
    background-image: none;
  }

  .title-sec {
    margin-bottom: 56px;
    h2 {
    color: #FFFFFF;
    font-family: Montserrat;
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: 120%;
    span {
      color: #FFFFFF;
      font-weight: 600;
    }
  }

  p {
    color: #FFFFFF;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    margin-bottom: 0px;
  }
  }
  
  video {
    max-width: 1100px;
    @media (max-width: 850px) {
        max-width: 343px;
      margin-bottom: 100px;
    }
  }

  .video-institutional {
    display: flex;
    justify-content: center;
    margin-top: 40px;
  }

  .title-container {
    display: flex;
    flex-direction: column;
    align-items: center;

    h2 {
      color: #375F92;
      text-align: center;
      font-size: 40px;
      font-weight: 700;
      line-height: 100%;
      letter-spacing: -0.8px;
      margin-bottom: 24px;
    }
    p {
      
      color: #666;
      text-align: center;
      font-size: 16px;
      font-weight: 500;
      line-height: 150%;
      max-width: 920px;

      @media (max-width: 850px) {
        max-width: 335px;
      }
    }
  }

  .text-container {
    display: flex;
    justify-content: center;
    padding-block: 52px;
    
    @media (max-width: 850px) {
      background-image: url(${videoShapeMobile});
    background-repeat: no-repeat;
    background-size: cover;
    
      p {

        max-width: 343px !important;
      }
    }

    p {
      color:#375F92;
      font-size: 40px;
      font-weight: 700;
      line-height: 120%;
      letter-spacing: -0.8px;
      max-width: 862px;
      .full-text {
        color: #8A588D;
        .socioemocional {
          color: #8A588D;
          font-size: 40px;
          font-weight: 800 !important;
          line-height: 120%;
          letter-spacing: -0.8px;
        }
      }
    }
  }

  button {
    border-radius: 16px;
    background: #3C5F3F;
    border: none;
    color: #FFEBD2;
    text-align: center;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;
    padding: 15px 56px;
  }

  button:hover {
    background-color: #5F8966;
  }
  button:active {
    background-color: #232D23 !important;
    border-color: #232D23 !important;
    box-shadow: none !important;
  }
  button:focus {
    background-color: #232D23 !important;
    border-color: #232D23 !important;
    box-shadow: none !important;
  }
`

